module.exports = __webpack_public_path__ + "static/media/4star.3205ae7a.svg";